import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5c1b32ac&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=5c1b32ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b32ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c1b32ac')) {
      api.createRecord('5c1b32ac', component.options)
    } else {
      api.reload('5c1b32ac', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=5c1b32ac&scoped=true", function () {
      api.rerender('5c1b32ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/documents/popup/condition/main.vue"
export default component.exports